import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { Button, ErrorMsg } from "@onegovbugs/onegov-react-components";
import { hasAnyValue, validate } from "../../../utils/Validation";
import styles from "./FocusOfWork.module.scss";
import { storeSpeciesData, saveApplication } from "../../../redux/actions";
import { RedirectIfCaptchaNotSelected } from "../../../utils/Redirect";
import ScrollToTop from "../../../utils/ScrollToTop";
import FocusOfWorkList from "../../../components/floraFauna/focusOfWork/FocusOfWorkList";

const FocusOfWorkDetail = (props) => {
  RedirectIfCaptchaNotSelected(props);
  ScrollToTop();

  const dispatch = useDispatch();

  const focusOfWorkDetail = useSelector((state) => state.focusOfWorkDetail);
  const [focusOfWorkList, setFocusOfWorkList] = useState(
    focusOfWorkDetail && focusOfWorkDetail.focusOfWorkList
      ? focusOfWorkDetail.focusOfWorkList.map((on) => ({ ...on }))
      : []
  );

  const storeData = (finished) => {
    const focusOfRecord = {
      focusOfWorkList,
      finished: finished,
      step : 7
    };
    dispatch(storeSpeciesData(focusOfRecord));
  };

  //validaitons
  const [showErrors, setShowErrors] = useState(false);
  const [errors, setErrors] = useState({
    locationList: false,
  });

  const validators = [
    {
      fieldName: "focusOfWorkList",
      fieldValue: focusOfWorkList,
      isValid: hasAnyValue,
    },
  ];
  useEffect(() => {
    validate(validators, setErrors);
  }, [focusOfWorkList]);

  const deleteActionHandler = (i) => {
    let values = [...focusOfWorkList];
    values.splice(i, 1);
    setFocusOfWorkList([...values]);
    
    const focusOfWork = {
      focusOfWorkList: values
    };
    dispatch(storeSpeciesData(focusOfWork));
  };

  return (
    <div className={styles.mainCont}>
      <div className={"row"}>
        <div className={`col-12`}>
          <p>
            Select a <b>'Species Type'</b> for all records, <b>'FA'</b> Fauna, <b>'FL'</b> Flora, <b>'TEC' </b> 
            Threatened Ecological Communities or <b>'Other'</b> i.e. mostly
            abiotic samples such as soil or water.
          </p>
          <p>
            For projects involving <b>FA</b> and <b>FL</b> type in any part of the scientific
            name from Family down to sub-species and then make your selection
            from the list.
          </p>
          <p>
            Selecting a Family name only e.g. 'Scincidae' means that you intend
            to work on all species in the Family Scincidae, while selecting
            Family and a genus e.g. 'Scincidae Carlia' will indicate that you
            intend to work on all species in the <i>genus Carlia</i>.
          </p>
          <p>
            If your project focuses on a broad range of species select the
            relevant 'Species Type' and then type 'All' and select a value that
            matches your project e.g. 'ALL FAUNA', 'ALL BATS' or 'ALL FLORA'
          </p>
          <p>
            For projects in an <b>'TEC'</b>, type in any part of the name of the
            community and select the value from the list. For a list of <b>TEC</b>'s
            click{" "}
            <a
              target="_blank"
              href="https://www.environment.nsw.gov.au/savingourspeciesapp/default.aspx"
            >
              here
            </a>
            , select Type = 'Threatened Ecological Communities’ and click Search.
          </p>
          <p>
            A full list of 'Other' values can be found{" "}
            <a
              target="_blanl"
              href="https://www.environment.nsw.gov.au/licences-and-permits/scientific-licences/apply-for-a-scientific-licence#accordion-Species-that-arent-listed"
            >
              here
            </a>
            .
          </p>
          <p>
            For all records you will need to select a <b>target part</b>, <b>sample unit </b>
            and a proposed <b>'number of target parts'</b>.
          </p>
        </div>
        <br />
        <div className={"col-12"}>
          <FocusOfWorkList
            props={props}
            focusOfWorkList={focusOfWorkList}
            deleteActionHandler={deleteActionHandler}
          />
        </div>
      </div>
      <div className={`row ${styles.buttonCont}`}>
        <div className={`col-12`}>
          <Button
            secondary
            onClick={() => {
              props.history.push(`./focusOfWork/detail`);
            }}
          >
            Add focus of work
          </Button>
        </div>
      </div>
      {errors.focusOfWorkList && showErrors ? (
        <ErrorMsg type={"error"} description={"Please add focus of work."} />
      ) : null}

      <div className={`row ${styles.buttonCont}`}>
        <div className={`col-12`}>
          <Button
            onClick={() => {
              if (validate(validators, setErrors)) {
                storeData(true);
                dispatch(
                  saveApplication("step7", () => {
                    props.history.push(`../../flora-fauna/dashboard`);
                  })
                );
                setShowErrors(false);
              } else {
                setShowErrors(true);
              }
            }}
          >
            Continue
          </Button>

          <Button
            secondary
            onClick={() => {
              storeData(false);
              dispatch(
                saveApplication("step7", () => {
                  props.history.push(`../../flora-fauna/dashboard`);
                })
              );
            }}
          >
            Save & exit section
          </Button>
        </div>
      </div>
    </div>
  );
};

export default withRouter((props) => <FocusOfWorkDetail {...props} />);
